import Vue from 'vue';
import FileDetailModal from './fileDetail.vue';

let detailModalInstance;

function getInstance() {
  if (detailModalInstance) return detailModalInstance;
  const instance = new Vue({
    render(h) {
      return h(FileDetailModal, {});
    },
  });
  const component = instance.$mount();

  document.body.appendChild(component.$el);

  detailModalInstance = component;
  return detailModalInstance;
}

function modal(props) {
  const instance = getInstance(props);
  instance.$children[0] && instance.$children[0].show(props);
}

export default {
  show(props) {
    modal(props);
  },
};
